import { render } from "./PasswordResetApp.vue?vue&type=template&id=5bdcbc32&scoped=true"
import script from "./PasswordResetApp.vue?vue&type=script&lang=js"
export * from "./PasswordResetApp.vue?vue&type=script&lang=js"

import "./PasswordResetApp.vue?vue&type=style&index=0&id=5bdcbc32&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdcbc32"]])

export default __exports__